<div class="h-full flex flex-col bg-white relative">

    <!-- Header -->
    <div class="p-4 text-zinc-900 bg-zinc-50 border-b border-zinc-200 flex-shrink-0 w-full">
        <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-2 min-w-0 flex-1">
                <app-icon [type]="'file-text'" [class]="'h-4 w-4 flex-shrink-0'" [source]="'lucide'"
                    [size]="'default'"></app-icon>
                <h2 class="text-md font-medium truncate max-w-[600px] lg:max-w-[400px]">
                    {{ (selectedDocumentFile() && selectedDocumentFile().filename) || 'Document Preview' }}
                </h2>
            </div>

            <div class="flex items-center gap-2 flex-shrink-0">

                @if (canPublishAsDashboard()) {
                <button
                    class="flex items-center gap-1.5 px-3 py-2 rounded-lg theme-bg text-white text-sm font-medium cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                    [disabled]="publishingDashboard()" (click)="onPublishDashboard()">
                    <app-icon [type]="'send'" [class]="'h-3.5 w-3.5'" [source]="'lucide'" [size]="'default'"></app-icon>
                    <span>{{ publishingDashboard() ? 'Publishing…' : 'Publish dashboard' }}</span>
                </button>
                }

                @if(fileVersionsOptions().length > 1) {
                <div class="relative">
                    <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2"
                        (click)="openFileVersionDropdown($event)" pTooltip="Version History" tooltipPosition="bottom"
                        tooltipStyleClass="min-w-max">
                        <app-icon [type]="'history'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                            [size]="'default'"></app-icon>
                    </div>
                    <div class="absolute inset-y-0 inset-x-[-4rem] opacity-0 pointer-events-none">
                        <app-select #fileVersionSelect [options]="fileVersionsOptions()" [config]="fileVersionsConfig"
                            [value]="selectedFileVersion()" (onChange)="onFileVersionChange($event.value)" />
                    </div>
                </div>
                }

                <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2"
                    (click)="openDocumentFullscreen()" pTooltip="Expand" tooltipPosition="bottom"
                    tooltipStyleClass="min-w-max">
                    <app-icon [type]="'expand'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                        [size]="'default'"></app-icon>
                </div>

                <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2" (click)="downloadDocument()"
                    pTooltip="Download" tooltipPosition="bottom" tooltipStyleClass="min-w-max">
                    <app-icon [type]="'square-arrow-down'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                        [size]="'default'"></app-icon>
                </div>
                <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2"
                    (click)="closeDocumentPreview()">
                    <app-icon [type]="'x'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                        [size]="'default'"></app-icon>
                </div>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-hidden relative bg-gray-50">
        @if(selectedDocumentFile()) {
        <app-multi-format-preview [documentId]="selectedDocumentId()" [file]="selectedDocumentFile()"
            class="h-full w-full" [loading]="fileLoading()" [pageNumber]="pageNumber()">
        </app-multi-format-preview>
        } @else {
        <div class="h-full w-full flex items-center justify-center">
            <div class="text-center">
                <p class="text-gray-600">No document selected</p>
            </div>
        </div>
        }
    </div>
</div>

<!-- Fullscreen dialog — rendered via CDK portal (appended to body), bypassing parent stacking contexts -->
<app-dialog [visible]="isDocumentFullscreenOpen()" (visibleChange)="isDocumentFullscreenOpen.set($event)"
    class="!fixed !inset-0 !w-screen !h-screen !max-w-none !max-h-none !rounded-none !translate-x-0 !translate-y-0 !top-0 !left-0 !p-0 !gap-0 flex flex-col"
    [showCloseButton]="false" [closable]="false">
    <ng-template #headerTemplate>
        <div class="p-4 text-zinc-900 bg-zinc-50 border-b border-zinc-200 flex-shrink-0 w-full">
            <div class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-2 min-w-0 flex-1">
                    <app-icon [type]="'file-text'" [class]="'h-4 w-4 flex-shrink-0'" [source]="'lucide'"
                        [size]="'default'"></app-icon>
                    <h2 class="text-md font-medium truncate max-w-[600px] lg:max-w-[400px]">
                        {{ (selectedDocumentFile() && selectedDocumentFile().filename) || 'Document Preview' }}
                    </h2>
                </div>
                <div class="flex items-center gap-2 flex-shrink-0">
                    @if (canPublishAsDashboard()) {
                    <button
                        class="flex items-center gap-1.5 px-3 py-2 rounded-lg theme-bg text-white text-sm font-medium cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                        [disabled]="publishingDashboard()" (click)="onPublishDashboard()">
                        <app-icon [type]="'send'" [class]="'h-3.5 w-3.5'" [source]="'lucide'"
                            [size]="'default'"></app-icon>
                        <span>{{ publishingDashboard() ? 'Publishing…' : 'Publish dashboard' }}</span>
                    </button>
                    }
                    <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2"
                        (click)="closeDocumentFullscreen()" pTooltip="Minimize" tooltipPosition="bottom"
                        tooltipStyleClass="min-w-max">
                        <app-icon [type]="'minimize-2'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                            [size]="'default'"></app-icon>
                    </div>
                    <div class="cursor-pointer border border-arena-gray-200 rounded-lg p-2" (click)="downloadDocument()"
                        pTooltip="Download" tooltipPosition="bottom" tooltipStyleClass="min-w-max">
                        <app-icon [type]="'square-arrow-down'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                            [size]="'default'"></app-icon>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex-1 overflow-hidden relative bg-gray-50 h-full">
            @if(selectedDocumentFile()) {
            <app-multi-format-preview [documentId]="selectedDocumentId()" [file]="selectedDocumentFile()"
                class="h-full w-full" [loading]="fileLoading()" [pageNumber]="pageNumber()">
            </app-multi-format-preview>
            }
        </div>
    </ng-template>
</app-dialog>